import { Box, HStack, VStack } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { Image } from '@common/components/Image';
import { useInvestorAccountModel } from '@common/models/InvestorAccountModel';
import { FontFamily } from '@common/theming/Fonts';
import currency from '@common/utility/currency';
import React from 'react';
import { TextBlock } from '../../common/components/TextBlock';

export const Balance: React.FC = () => {
  const investorAccountModel = useInvestorAccountModel();
  const change = Number(investorAccountModel.investorAccount?.tally_dividends);
  let balance = parseFloat(investorAccountModel.accountValue?.total_value ?? '0');
  if (isNaN(balance)) {
    balance = 0;
  }

  return (
    <Box
      flex={1}
      display={'flex'}
      flexDirection={'row'}
      border={'1px dashed black'}
      borderRadius="10px"
      h={'220px'}
      position="relative"
      backgroundColor="blackAlpha.900">
      <Image zIndex={1} position="absolute" image="balance-background" alignSelf="flex-end" />
      <VStack alignItems="flex-start" zIndex={2} pl="30" justifyContent="space-between" py="30px">
        <TextBlock fontFamily={FontFamily.HELVETICA_NOW_BOLD} color="white">
          Balance
        </TextBlock>
        <TextBlock
          title={`$${balance.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
          fontFamily={FontFamily.HELVETICA_NOW_BOLD}
          fontSize={['48px', '64px', '48px', '64px']}
          lineHeight={['48px', '64px', '48px', '64px']}
          h={['48px', '64px', '48px', '64px']}
          background="linear-gradient(181.78deg, #63AAFF 18.77%, #63AAFF 29.07%, #C7E0FF 42.24%, #FFD698 55.01%, #C4A8FF 74.51%)"
          backgroundClip="text"
          color="transparent">
          {currency.format(balance, {
            compactDisplay: balance < 1000000 ? 'long' : 'short',
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          })}
        </TextBlock>
        <HStack h="30px" alignItems="center">
          {change >= 0 ? (
            <Icon fontSize="24px" color="green.400" icon="caret-up" />
          ) : (
            <Icon fontSize="24px" color="red" icon="caret-down" />
          )}
          <TextBlock fontSize={'24px'} color="white" weight="bold">
            {currency.format(change, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
          </TextBlock>
          <TextBlock fontSize={'24px'} color="lightgray">
            all time
          </TextBlock>
        </HStack>
      </VStack>
    </Box>
  );
};
